export default "__VITE_ASSET__DzINWLBk__"